import * as SineWaves from 'sine-waves';

class HeroSine {
  constructor() {
    this.smoothEl = document.getElementById('smooth');
    this.colors = {
      lightgrey: 'rgba(0,0,0,0.05)',
      darkgrey: 'rgba(0,0,0,0.2)',
      blue: 'rgba(0,68,148, 0.7)',
    };
  }

  init() {
    if (!this.smoothEl) {
      return;
    }

    if (window.matchMedia('(min-width: 760px)').matches) {
      this.desktopSine();
    } else {
      this.mobileSine();
    }
  }

  desktopSine() {
    /* eslint-disable no-new */
    // Datenstränge
    new SineWaves({
      el: this.smoothEl,
      speed: 1,
      // ease: 'SineInOut',
      ease: (percent, amplitude) => amplitude * (percent / 0.8),
      rotate: 2,
      waves: [
        {
          // Smooth
          timeModifier: 1,
          lineWidth: 3,
          amplitude: 50,
          wavelength: 100,
          segmentLength: 1,
          strokeStyle: this.colors.darkgrey,
        },
      ],
    });
    /* eslint-enable no-new */
  }

  mobileSine() {
    /* eslint-disable no-new */
    // Datenstränge
    new SineWaves({
      el: this.smoothEl,
      speed: 1,
      // ease: 'SineInOut',
      ease: (percent, amplitude) => amplitude * (percent / 0.8),
      rotate: 2,
      waves: [
        {
          // Smooth
          timeModifier: 1,
          lineWidth: 3,
          amplitude: 100,
          wavelength: 200,
          segmentLength: 1,
          strokeStyle: this.colors.darkgrey,
        },
      ],
    });
    /* eslint-enable no-new */
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeroSine().init();
});
